





















































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'PrivacyAgreement'
})
export default class PrivacyAgreement extends Vue {
  created() {
    document.title = '用户隐私协议';
  }
}
